import {
  isSentry
} from './lib';
import randToken from 'rand-token';

import putBlobInDb from './IndexedDB';

const essentials = {
  recordTabTitle: '録画するために、ここを選択してください。',
}

const errors = {
  cancelled: 'Not allowed',
}
export async function getRecordStream(streamId) {

  if (!streamId) {
    return 'Not allowed';
  }
  const constraints = {
    "video": {
      mandatory: {
        chromeMediaSource: 'desktop',
        chromeMediaSourceId: streamId,
        minWidth: 1280,
        minHeight: 720,
        maxWidth: 1280,
        maxHeight: 720
      }
    },
    "audio": {
      mandatory: {
        chromeMediaSource: 'desktop',
        chromeMediaSourceId: streamId
      }
    }
  };
  navigator.mediaDevices.getUserMedia(constraints)
    .then((streamy) => {
      const copiedStream = streamy.clone();
      const obj = {}
      const recording = new MediaRecorder(streamy, {
        mimeType: 'video/webm'
      });
    })
    .catch(err => {
      isSentry(err)
      window.postMessage({
        type: "gotRecordingStream",
        stream: "Not allowed"
      }, "*")
    });
  let stream = "none";
  try {
    stream = await navigator.mediaDevices.getUserMedia(constraints);
  } catch (err) {
    isSentry(err)
  }
  return stream;
}

// via: https://stackoverflow.com/a/12300351/552182
export function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  var blob = new Blob([ab], {
    type: mimeString
  });
  return blob;
}


export function getTimeFromSeconds(allSeconds, options) {
  let sec_num = parseInt(allSeconds, 10); // don't forget the second param
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  if (options && "includeHours" in options) {
    return hours + ":" + minutes + ':' + seconds;
  }
  return minutes + ':' + seconds;
}

export function convertMinutesToSeconds(minutes) {
  return minutes * 60;
}

export function convertFileToBlobAndPutInDb(that, blob, randomKey) {
  return putBlobInDb(blob, randomKey, that.roomName, (payload) => {
    if (!payload.success) {
      that.setState({
        snackbarOpen: true,
        snackbarMessage: payload.reason
      });
    } else {
      that.setState({
        listModalOpen: true,
        listModalPurpose: 'endRecording',
        isRecording: false,
        recordingKey: null,
        recordingTime: 0,
      });
    }
    window.removeEventListener("message", onRecordRelatedMessage, false);
  });
}

export function onRecordRelatedMessage(message) {
  let randomKey;
  const {
    recordingTime
  } = this.state;
  if (message.data.type === "gotRecordingChunk") {
    randomKey = randToken.generate(6);
    convertFileToBlobAndPutInDb(this, message.data.data, randomKey);
  };

  if (message.data.type === "got30MinRecording") {
    randomKey = randToken.generate(6);
    const {
      data
    } = message.data;
    putBlobInDb(data, randomKey, this.roomName, (payload) => {
      if (!payload.success) {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: payload.reason
        });
        isSentry(payload.reason);
      }
      window.postMessage("continueRecordStream");
    })
  }

  if (message.data.type === "gotRecordingChunkFromInactivity") {
    randomKey = randToken.generate(7);
    convertFileToBlobAndPutInDb(this, message.data.data, randomKey);
  };
  if (message.data.type === "recordingExtensionError") {
    isSentry(`Error occurred in extension: ${message.data.data}`);
  }
  if (message.data.type === "addSecondToRecordingTime") {
    if (recordingTime + 1 >= this.recordingLimit) {
      window.postMessage({
        type: "get30MinRecording"
      });
      this.setState({
        recordingTime: 0
      });
    } else {
      this.setState({
        recordingTime: recordingTime + 1,
      });
    }
  };
  if (message.data.type === "cancelRecording") {
    this.onStopScreenRecording();
    return window.removeEventListener("message", this.onRecordRelatedMessage, false);
  }
  if (message.data.type === "gotRecordingStream") {
    const {
      streamId
    } = message.data;
    document.title = this.state.tabTitle;
    if (streamId === errors.cancelled) {
      this.recordingStream = null;
      return this.setState({
        isRecording: false
      });
    }
    const randomKey = randToken.generate(6);

    this.setState({
      isRecording: true,
      recordingKey: randomKey
    });
  }
  if (message.data.type === "gotRecordingDesktopId") {
    const {
      desktopId
    } = message.data;
    this.recordingDesktopId = desktopId;
  }
}



// WEBPACK FOOTER //
// ./src/lib/recordHelpers.js